class LiveClock {
    constructor(element) {
      this.element = element;
      this.timezone = element.dataset.timezone;
      this.updateClock();
      
      setInterval(() => this.updateClock(), 1000);
    }
  
    updateClock() {
      const time = new Date();
      const formattedTime = new Intl.DateTimeFormat('en-US', {
        timeZone: this.timezone,
        hour12: false,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).format(time);
      
      this.element.textContent = formattedTime;
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    const clockElements = document.querySelectorAll('.clock');
    clockElements.forEach(element => new LiveClock(element));
  });